export default [
  {
    value: 'day',
    label: '按日汇总',
  },
  {
    value: 'week',
    label: '按周汇总',
  },
  {
    value: 'month',
    label: '按月汇总',
  },
  {
    value: 'quarter',
    label: '按季度汇总',
  },
];
